import * as types from "./types";
import {
  JSON_STRING,
  HttpClient,
  MHTTPCL
} from "../../../../services/http/http-client";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { ShopsService } from "../../services/shops.service";
import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";
import router from "../../../../router";

// Action Object for ShopsDistribution. Import the types from shops/types.js and Invoke Actions from the Vuex Host Components.
const NavTabModule = getNavTabModule(types.ShopDetails, "shopDetails");

export const shopsDistributionActions = {
  async [types.ShopsData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const shopsData = await HttpClient.mergeRequests([
      ProductsService.costGeneralData()
    ]);
    console.log(shopsData);
    commit(types.ShopsData.SET.ALL, shopsData);
  },

  async [types.ShopList.FETCH.ALL]({ commit, getters, state }, payload) {
    // searchMode is Outputted by the Mixin. The Logic is automatically handled.

    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;
    console.log("Shop list - actions ", payload);

    let res;

    if (searchMode == "none") {
      if (start == 0) {
        res = await HttpClient.mergeRequests([
          ShopsService.getShops(),
          ShopsService.shopChannels()
        ]);
        // res = await ShopsService.getShops();
        console.log("Search mode -none ", res);
        commit(types.ShopList.SET.ALL, res); // <-- Directly Set the Data. Depends on your particular Logic
      } else {
        // <-- Pagination Logic
        const { searchString, channel } = basicFilter;
        res = await ShopsService.getShopsScroll(channel, searchString, start); // <-- Pagination Logic
        console.log("Search mode -none & scroll ", res.data.shops);
        commit(types.ShopList.SET.ALL, {
          // <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.shopList,
          shops: [
            ...getters.shopList.shops,
            ...res.data.shops // <-- append new Fetched List
          ]
        });

        // Setting EOL
        if (!(res?.data?.shops?.length > 0)) {
          return EOL_REACHED;
        }
      }
    } else if (searchMode == "basic") {
      const { searchString, channel } = basicFilter;
      console.log("Search mode --basic, basicfilter ", basicFilter);

      res = await ShopsService.searchShops(channel, searchString);
      console.log("Search mode --basic ", res.data.shops);

      if (start == 0) {
        commit(types.ShopList.SET.ALL, {
          // <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.shopList,
          shops: res.data.shops
        });
      } else {
        // <-- Pagination Logic
        commit(types.ShopList.SET.ALL, {
          // <-- Pagination Logic
          ...getters.shopList,
          shops: [
            ...getters.shopList.shops,
            ...res.data.shops // <-- append new Fetched List
          ]
        });
      }

      // Setting EOL
      if (!(res?.data?.shops?.length > 0)) {
        return EOL_REACHED;
      }
    }
  },

  async [types.ShopList.DELETE.SINGLE]({ commit, getters, state }, payload) {
   

    const { shop_id } = payload;
        //console.log("Search mode -none & scroll ", res.data.shops);
        commit(types.ShopList.SET.ALL, {
          ...getters.shopList,
          shops:getters.shopList.shops.filter(e=>e.shop_id!=shop_id),
        });
    ShopsService.removeShop(shop_id)
  },

  // Show Sidewindow
  async [types.ShopDetails.FETCH.SINGLE](
    { commit, getters, dispatch },
    payload = {}
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("shop", payload);

    let { flag, shop, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "shop_id";
    const itemName = "shop";
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "shopDetails";
    const DetailsAction = types.ShopDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const detailsData = await HttpClient.mergeRequests([
      ShopsService.fetchShopDetailsTabOverview(shop.shop_id)
      // labelsService.fetchLabelDetailsTabOverview(label.shop_id)
      // TracksService.fetchTrackDetailsReleaseProductLicensing(track.track_id),
      // TracksService.trackDetailsMetadata(track.track_id),
      // TracksService.showMetadata(track.track_id),
      // TracksService.fetchTrackDetailsSales(track.track_id),
      // TracksService.getLabelCopy(track.track_id),
    ]);

    console.log("detailsData", detailsData);

    // DBox
    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, shop) => {
        return {
          ...shop,
          ...detailsData,
          loading: false
        };
      }
    );
  },

  // Left NavItem child details
  ...NavTabModule.implementActions(
    "shop_id",
    "shops/shop_id/tab",
    "shops",
    () => router,
    "distribution",
    (value, key) => {
      console.log("WWW", value);
      // if (value.shop) {
      //   console.log("value.shop ");
      //   return {
      //     // title: value && value.shop && value.shop.shop ? value.shop.shop : key,
      //     // full_title:
      //     //   value && value.shop && value.shop.shop ? value.shop.shop : key

      //     title: value?.shop?.shop
      //       ? `${value.shop.shop} ${
      //           value.shop.channel == "" || value.shop.channel == null
      //             ? ""
      //             : `(${value.shop.channel})`
      //         }`
      //       : key,
      //     full_title: value?.shop?.shop ? value.shop.shop : key
      //   };
      // } else if (value.single_translation) {
      //   console.log("value.single_translation ");

      const t = value?.single_translation?.text01 || value?.shop?.shop || key;
      const channel =
        {
          physical_shop: "physical",
          digital_shop: "digital"
        }[(value?.single_translation?.physical_shop)] ||
        value?.shop?.channel ||
        "physical";
      const title = `${t} (${channel})`;

      return {
        title: title,
        full_title: title
      };
    }
  ),

  async [types.ShopGroups.SET.ALL]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("set payload ", payload);
    const { related_shop_groups, selectedShopDetails } = payload;
    const { shop } = selectedShopDetails;
    const { shop_id } = shop;

    NavTabHelper.updateSingleNavTabDetails(shop_id, shopDetailsObj => {
      return {
        related_shop_groups
      };
    });
  },

  async [types.ShopGroups.DELETE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("SG Delete by Action ", payload);
    const { shop_relation_id, shop_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(shop_id, shopDetailsObj => {
      return {
        related_shop_groups: shopDetailsObj.related_shop_groups.filter(
          e => e.shop_relation_id != shop_relation_id
        )
      };
    });
    await ShopsService.removeShopGroup(shop_relation_id);
  }
};
